module.exports = __webpack_public_path__ + "media/images/swifticons/thumbs-up-clicked-bb4e3693817c8ffa9f7bb1c274a402cd.svg";